<template>
  <v-container>
    <v-form>
      <v-row align="center" justify="start">
        <v-col>
          <v-text-field
            v-model="ctext"
            required
            label="Recopiez le texte ci-contre"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-img :src="embedImage" width="120" height="40"> </v-img>
        </v-col>
        <v-spacer />
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CaptchaWidget",
  props: ["cimage", "cvalue"],
  data() {
    return {};
  },
  computed: {
    ctext: {
      get() {
        return this.cvalue;
      },
      set(value) {
        this.$emit("update:cvalue", value);
      }
    },
    embedImage() {
      return "data:image/png;base64," + this.cimage;
    }
  },
  methods: {}
};
</script>

<style></style>
